<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Fatura Aktatım Tarihcesi</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->

          <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body">
              <!--begin: Datatable -->
              <div
                id="m_table_1_wrapper"
                class="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div class="row"></div>
                <div class="row">
                  <div class="col-sm-12">
                    <table
                      class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer dtr-inline"
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px"
                            aria-label="Order ID: activate to sort column ascending"
                          >
                            UuId
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px"
                            aria-label="Order ID: activate to sort column ascending"
                          >
                            Numara
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Referans
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Mesaj
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Dönüş Kodu
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Durum
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Tip
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Son Güncelleme
                          </th>
                            <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            İptal mi?
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="model.items && model.items.length">
                        <tr
                          role="row"
                          class="odd"
                          v-for="item in model.items"
                          v-bind:key="item.id"
                        >
                          <td>{{ item.uuId }}</td>
                          <td>{{ item.number }}</td>
                          <td>{{ item.referenceId }}</td>
                          <td><div style="height:80px; overflow:auto">{{ item.message }} </div></td>
                          <td>{{ item.responseCode }}</td>
                          <td>{{ item.operationStatusDescription }}</td>
                          <td>{{ item.documentTypeDescription }}</td>
                          <td>
                            {{
                              item.currentDate
                                | moment(false, "yyyy-MM-dd'T'HH:mm").format(
                                  "DD/MM/YYYY"
                                )
                            }}
                          </td>
                        <td>{{ item.isCancel }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--end::Portlet-->
          <div class="m-portlet m-portlet--mobile">
            <paginate
              :page-count="
                Math.ceil(this.model.totalCount / this.model.pageSize)
              "
              :click-handler="changePage"
              :prev-text="'←|'"
              :next-text="'|→'"
              :container-class="'pagination'"
            >
              >
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { _searchInvoiceRecordsHistory } from "../../services/InvoiceService";
import datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      model:{
        items: [],
        page:0,
        pageSize:0,
        totalCount:0
      },
        seachModel: {
        id:0,
        page: null
      },
      status: [],
      documentTypes: [],
    };
  },
  created() {
          this.seachModel.id=Number(this.$route.params.id);
          this.getAll();
  },
    components: {
    datepicker: datepicker
  },
  methods: {
    getAll: function() {
      // let loader=this.$loading.show();
      _searchInvoiceRecordsHistory(this.seachModel).then(response => {
        this.model = response.data.data;
      });
    },
        changePage: function(page) {
      this.seachModel.page = page;
      this.getAll();
    }
  }
};
</script>